<template>
  <v-dialog v-model="visible" persistent :max-width="width">
    <v-card>
      <v-card-title class="headline">
        {{ title }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text v-if="item">
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              :label="`姓名`"
              background-color="#49bcfd"
              outline
              v-model="editedItem.name"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              :label="`身份證`"
              background-color="#49bcfd"
              outline
              v-model="editedItem.memberId"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              :label="`電話`"
              background-color="#49bcfd"
              outline
              v-model="editedItem.cellphone"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              :label="`公司電話`"
              background-color="#49bcfd"
              outline
              v-model="editedItem.companyPhone"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              :label="`生日`"
              background-color="#49bcfd"
              outline
              v-model="editedItem.birthday"
            ></v-text-field>
          </v-flex>
        </v-layout>


        <v-layout row wrap>
          <v-flex md6>
            <v-autocomplete
              v-model="editedItem.agentId"
              background-color="#49bcfd"
              outline
              :items="agentList"
              label="經銷"
              item-text="displayName"
              item-value="agentId"
            ></v-autocomplete>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
<!--        <v-btn color="red" dark text v-if="!isNew" @click="deleteEvent">刪除</v-btn>-->
        <v-spacer></v-spacer>
        <v-btn text @click="cancelEvent">取消</v-btn>
        <v-btn color="primary" :loading="loading" dark text @click="confirmEvent">確定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import MobileDetect from "mobile-detect";
import { mapActions, mapGetters } from 'vuex';
import DatePicker from "@/components/DatePicker";
import common from '@/mixins/common';
import CaseFinanceModel from '@/models/CarFinanceModel';
const md = new MobileDetect(window.navigator.userAgent);
export default {
  name: 'AssignorDialog',
  components:{ DatePicker },
  props: {
    visible: Boolean,
    title: String,
    item: Object,
    isNew: Boolean,
    loading: Boolean,
  },
  mixins:[common],
  data() {
    return {
      width: md.phone() ? "80%" : "50%",
      type: 0,
      menu: false,
      fileList:[],
      uploadFieldName: 'files',
      files: [],
      message: '',
      agentItems: [],
    };
  },
  created() {
  },
  computed: {
    ...mapGetters(["getUserInfo",'getAgentList']),
    editedItem() {
      return this.item;
    },
    agentList(){
      return this.getAgentList.filter(agent=>agent.enable === true);
    },
  },
  watch: {
    visible(value) {
      console.log(`car finance visible = ${value}`);
      if (this.isNew){
        this.item.agentId = this.getUserInfo.agentId;
      }
      if (value){
        this.files = [];
        this.fetchAgentList();
      }
    },
    loading(value) {
      console.log(`car finance loading = ${value}`);
    }
  },
  methods: {
    ...mapActions(['fetchAgentList',]),
    confirmEvent() {
      this.message = '';

      if (!this.editedItem.name || this.editedItem.name === ''){
        this.showMessageDialog('請輸入姓名！')
        return;
      }

      if (!this.editedItem.memberId || this.editedItem.memberId === ''){
        this.showMessageDialog('請輸入身份證！')
        return;
      }
      this.$emit("confirmEvent", { item: this.editedItem, files: this.files });
    },
    cancelEvent() {
      this.files = [];
      this.message = '';
      this.$emit("cancelEvent");
    },
    deleteEvent(){
      this.$emit("deleteEvent", this.editedItem.caseId);
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AssignorDialog.vue